
import { defineComponent } from "vue"
import CardsManagementForm from "@/components/cards_management/Form.vue"

export default defineComponent({
  components: {
    CardsManagementForm
  }
})
